import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import PropTypes from 'prop-types';
import MyStudentsPageFeaturewall from './MyStudentsPageFeaturewall';
import MyStudentsPage from './MyStudentsPage';
import AddStudentsFlow from './AddStudentsFlow';
import API from './MyStudentsPage/api';
import { getGradeMap } from './api';

const AVATARS = {
  1: 'tutu',
  2: 'penelope',
  3: 'roly',
  4: 'cuzcuz',
  5: 'muggo',
  6: 'icecream',
  7: 'floyd',
  8: 'birdy'
};

export const GradeContext = React.createContext({});

const MyStudents = (props) => {
  const {
    isTeacher,
    isSchoolAdmin,
    maxPlayers: maxPlayers1,
    players: players1,
    googleClassroomApiKey
  } = props;

  const [yourX] = useState({
    singular: isTeacher ? 'student' : 'child',
    plural: isTeacher ? 'students' : 'children'
  });
  const [players, setPlayers] = useState(players1);
  const [maxPlayers] = useState(maxPlayers1);
  const [loading, setLoading] = useState(false);
  const [unlockText] = useState(
    isSchoolAdmin
      ? 'you must be added to the teachers list on your school account.'
      : 'so that you can assign items from our Learning Library and track their growth!\n'
  );
  const [gradeMap, setGradeMap] = useState(null);

  useEffect(() => {
    async function getGrades() {
      const grades = await getGradeMap();
      setGradeMap(grades)
    }

    getGrades();
  }, []);

  const handleAddStudents = (students) => {
    setLoading(true);

    API.bulkAddChildren(students.names, students.grade)
      .then((resp) => {
        const newPlayersData = resp.result;

        const newPlayers = {};
        newPlayersData.forEach((player) => {
          const id = player.PlayerId;
          const avatarName = AVATARS[player.PlayerAvatarId];
          newPlayers[id] = {
            childId: id,
            name: player.PlayerName,
            studentCode: player.HomeCode,
            grade: player.PlayerGrade,
            avatar: {internalName: avatarName},
            lockedGrade: false,
            hiddenGrade: false
          }
        });

        setPlayers({...players, ...newPlayers});
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const value = {gradeMap};

  return (
    <GradeContext.Provider value={value}>
      <Router>
        <div>
          <Switch>
            <Route
              exact path="/my/students/premium-feature/"
              render={() =>
                <MyStudentsPageFeaturewall
                  yourX={yourX}
                  players={players}
                  updatePlayers={setPlayers}
                  unlockText={unlockText}
                  isSchoolAdmin={isSchoolAdmin}
                />
              }
            />
            <Route
              exact path="/my/students/"
              render={(argument) =>
                <MyStudentsPage
                  yourX={yourX}
                  players={players}
                  loading={loading}
                  updatePlayers={setPlayers}
                  maxPlayers={maxPlayers}
                  {...argument}
                />
              }
            />
            {/* Only route to add students page if current player length is less than max players,
                  Otherwise, redirect back to students page with an error notification */}
            <Route
              exact path="/my/students/add/"
              render={() =>
                (Object.keys(players).length < maxPlayers) ?
                  <AddStudentsFlow
                    yourX={yourX}
                    passNewStudentsToMyStudentsPage={handleAddStudents}
                    googleClassroomApiKey={googleClassroomApiKey}
                    maxPlayers={maxPlayers}
                    players={players}
                  /> : <Redirect to={{pathname:"/my/students/",  state: {addStudentRedirectError: true}}}/>
              }
            />
            <Redirect to="/my/students/" />
          </Switch>
        </div>
      </Router>
    </GradeContext.Provider>
  );
};

MyStudents.propTypes = {
  isTeacher: PropTypes.bool,
  isSchoolAdmin: PropTypes.bool,
  maxPlayers: PropTypes.number,
  players: PropTypes.shape(),
  googleClassroomApiKey: PropTypes.string
};

MyStudents.defaultProps = {
  isTeacher: false,
  isSchoolAdmin: false,
  maxPlayers: 1,
  players: [],
  googleClassroomApiKey: ""
};

export default MyStudents;
